import React, { useEffect } from "react";
import "./PlanningAssistancePage.css";

const PlanningAssistancePage = () => {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "auto",
    });

    const existingScript = document.querySelector(
      "script[data-formspace-embed]"
    );

    if (existingScript) {
      existingScript.remove();
    }

    const script = document.createElement("script");

    script.src = "https://formspace.com/embed.js";
    script.defer = true;
    script.crossOrigin = "anonymous";
    script.dataset.formspaceEmbed = "true";

    document.body.appendChild(script);

    return () => {
      script.remove();
    };
  }, []);

  return (
    <main className="planning-assistance-page">
      <section className="planning-assistance-heading">
        <p className="planning-assistance-eyebrow">
          Get Planning Help
        </p>

        <h1>Let us take the planning off your plate.</h1>

        <p>
          Tell us about your team, goals, budget, and preferences.
          Teamward will review your request and follow up with planning
          options, scope, and pricing.
        </p>
      </section>

      <section className="planning-pricing-note">
        <div
          className="planning-pricing-icon"
          aria-hidden="true"
        >
          <svg
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M4 4h6.2c.53 0 1.04.21 1.41.59l8.8 8.8a2 2 0 0 1 0 2.82l-4.2 4.2a2 2 0 0 1-2.82 0l-8.8-8.8A2 2 0 0 1 4 10.2V4Z"
              stroke="currentColor"
              strokeWidth="1.6"
              strokeLinecap="round"
              strokeLinejoin="round"
            />

            <circle
              cx="8"
              cy="8"
              r="1.25"
              stroke="currentColor"
              strokeWidth="1.6"
            />
          </svg>
        </div>

        <div>
          <h2>Submitting a planning request is free.</h2>

          <p>
            Full-service planning is a paid service. No planning work
            begins until you review and approve the scope and price.
          </p>
        </div>
      </section>

      <section className="planning-assistance-card">
        <header className="planning-form-header">
          <p className="planning-form-eyebrow">
            Planning Request
          </p>

          <h2>Tell us what your team needs.</h2>

          <p>
            Use this one request for personalized ideas, a custom
            package, or hands-on planning support. The more you share,
            the better we can tailor the next step to your group.
          </p>

          <div className="planning-form-highlights">
            <span>No fee to submit</span>
            <span>No obligation</span>
            <span>You approve pricing first</span>
          </div>
        </header>

        <div className="planning-form-frame">
          <div
            className="planning-assistance-embed"
            data-formspace="https://frontal-firestorm-840.forms.space/get-planning-assistance-aewfpy"
          />
        </div>
      </section>
    </main>
  );
};

export default PlanningAssistancePage;
